<template>
  <v-container fluid grid-list-lg class="mx-0 pa-0">
  <v-layout class="" id="scrollWrapper" row wrap>
    <v-flex xs12>
      <type-ahead :doc="this.$route.params.id"></type-ahead>
    </v-flex>
  </v-layout>
  </v-container>

</template>
<script>
  import TypeAhead from "../components/TypeAhead";
  export default {
    name: 'Search',
    data () {
      return {
      }
    },
    components: {
      TypeAhead
    },
    mounted () {
      this.$fetchData()

    }
  }
</script>
